import { IItemCapacity } from '../../interfaces/iitem-capacity';
import { Item } from '../item';
import { UnitOfMeasure } from '../unit-of-measure';

export class ItemCapacityBase {
  ItemCapacityId: number;
  ItemId: number;
  OilCapacity: number | null;
  WaterCapacity: number | null;
  GasCapacity: number | null;
  OilCapacityUnitOfMeasureId: number;
  GasCapacityUnitOfMeasureId: number;
  WaterCapacityUnitOfMeasureId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Item?: Item;
  GasCapacityUnitOfMeasure?: UnitOfMeasure;
  OilCapacityUnitOfMeasure?: UnitOfMeasure;
  WaterCapacityUnitOfMeasure?: UnitOfMeasure;

  constructor(item?: IItemCapacity) {
    if (item) {

      this.ItemCapacityId = item.ItemCapacityId;
      this.ItemId = item.ItemId;
      this.OilCapacity = item.OilCapacity;
      this.WaterCapacity = item.WaterCapacity;
      this.GasCapacity = item.GasCapacity;
      this.OilCapacityUnitOfMeasureId = item.OilCapacityUnitOfMeasureId;
      this.GasCapacityUnitOfMeasureId = item.GasCapacityUnitOfMeasureId;
      this.WaterCapacityUnitOfMeasureId = item.WaterCapacityUnitOfMeasureId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Item = new Item(item.Item);
      this.GasCapacityUnitOfMeasure = new UnitOfMeasure(item.GasCapacityUnitOfMeasure);
      this.OilCapacityUnitOfMeasure = new UnitOfMeasure(item.OilCapacityUnitOfMeasure);
      this.WaterCapacityUnitOfMeasure = new UnitOfMeasure(item.WaterCapacityUnitOfMeasure);
    }
  }
}